import { render, staticRenderFns } from "./DenialReceived.vue?vue&type=template&id=7b1f90f2&scoped=true&"
import script from "./DenialReceived.vue?vue&type=script&lang=js&"
export * from "./DenialReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1f90f2",
  null
  
)

export default component.exports